import { Suspense, lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const OrganizationFormPage = lazy(
  () => import('@/pages/dictionary-organizations/ui/OrganizationFormPage'),
)

export const Route = createFileRoute(
  '/_protected/dictionary/organizations/$inn',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <OrganizationFormPage />
    </Suspense>
  ),
})
